"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var subscribers = {};
exports.getSubscribers = function (url) {
    return Array.from(subscribers[url]);
};
exports.hasSubscribers = function (url) {
    return subscribers[url].size > 0;
};
exports.addSubscriber = function (url, subscriber) {
    subscribers[url] = subscribers[url] || new Set();
    subscribers[url].add(subscriber);
};
exports.removeSubscriber = function (url, subscriber) {
    subscribers[url].delete(subscriber);
};
//# sourceMappingURL=manage-subscribers.js.map